/**
 * Development-only logging. No-op in production.
 */
const dev = import.meta.env.DEV

export const devLog = (...args) => {
  if (dev) console.log(...args)
}
export const devWarn = (...args) => {
  if (dev) console.warn(...args)
}
export const devError = (...args) => {
  if (dev) console.error(...args)
}
